import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import * as actionTypes from "../../store/actions/actionTypes";
import {sendMessage} from "../../store/actions/admission";
import {useToasts} from "react-toast-notifications";
import Admission_ModalInfo from "../Block/Admission_ModalInfo";
import Admission_TargetPhone from "../Block/Admission_TargetPhone";
import useHtmlValidation from "../../utils/htmlValidation";

const ModalSendMessage = () => {
    const {valid, validationErrors, loading, resetValidation, validateHtml, hasErrors} = useHtmlValidation();
    const [text, setText] = useState('');
    const [patientTitle, setPatientTitle] = useState('');
    const [smsNotification, setSmsNotification] = useState(false);
    const [smsText, setSmsText] = useState('');
    const {addToast} = useToasts();
    const {show, admission} = useSelector(state => state.modal.sendMessage);
    const {selectedHospital} = useSelector(state => state.auth);

    useEffect(() => {
        setPatientTitle('');
        setSmsText('');
        setSmsNotification(false);
        setText('');
    }, [show]);

    const dispatch = useDispatch();
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_SEND_MESSAGE_HIDE});

    const doSendMessage = (event) => {
        // setSendClicked(true);
        dispatch(sendMessage(admission, addToast, patientTitle, text, smsNotification, smsText));
        event.preventDefault();
        dispatch({type: actionTypes.MODAL_SEND_MESSAGE_HIDE});
        // if ModalSendMessage is showed as child modal - close parent too
        dispatch({type: actionTypes.MODAL_ADMISSION_MESSAGES_HIDE})
    }

    const handleSmsNotification = (event) => setSmsNotification(event.target.checked);
    const handleSmsText = event => setSmsText(event.target.value);
    const handleTitle = event => setPatientTitle(event.target.value);

    const selectTemplate = event => {
        const templateId = event.target.value;
        console.log('Selected template' + templateId);
        setPatientTitle(selectedHospital.messageTemplates[templateId].title);
        setSmsText(selectedHospital.messageTemplates[templateId].sms_template);
        setSmsNotification(selectedHospital.messageTemplates[templateId].sms_enable);
        setText(selectedHospital.messageTemplates[templateId].message);
    }

    const renderTemplateSelection = () => {
        if (selectedHospital.messageTemplates.length) {
            return (
                <div className="form-group">
                    <div className="row">
                        <div className="col-4">
                            <select className="custom-select" id="inputGroupSelect01" onChange={selectTemplate}>
                                <option selected="">Select Template</option>
                                {selectedHospital.messageTemplates.map((item, key) => <option key={key} value={key}>{item.title}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    const modules = {
        toolbar: [
            // [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'], // , 'blockquote'
            // [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image', 'video'],
            ['clean']
        ],
    };

    const renderSmsTextBlock = () => {
        if (smsNotification) {
            return (
                <div className="form-group mb-4">
                    Sms text<br />
                    <textarea className="form-control" cols="30" rows="5" value={smsText} onChange={handleSmsText}>{admission.enablePatientPortalMessage}</textarea>
                </div>
            )
        }
        return null;
    }

    const handleChangeHtml = (text) => {
        setText(text);
        resetValidation();
    }

    const handleValidate = () => validateHtml(text);

    const renderModal = () => {
        if (show) {
            return (
                <div className="modal-dialog modal-content-large" role="document" ref={ref}>
                    <div className="modal-content modal-content-fit">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={hideModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="modal-body">
                            <h3>Send message to {admission.title} {admission.surname}, {admission.name}</h3>
                            <Admission_ModalInfo admission={admission} />
                            <form action="#" className="person-info-form">
                                {renderTemplateSelection()}

                                <div className="form-group mb-4">
                                    Title <br/>
                                    <input name="title" className="form-control" onChange={handleTitle} value={patientTitle}/>
                                </div>
                                <div className="form-group mb-4">
                                    Message <br/>
                                    {validationErrors()}
                                    <ReactQuill theme="snow" value={text} onChange={handleChangeHtml} modules={modules} className={`${hasErrors() ? 'error' : ''}`}/>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-4">
                                            <div className="custom-control custom-switch custom-switch-right-side">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="smsNotificationSwitch" checked={smsNotification} onChange={handleSmsNotification}/>
                                                <label className="custom-control-label"
                                                       htmlFor="smsNotificationSwitch">Sms notification?</label>
                                            </div>
                                        </div>
                                        <div className="col-8 d-flex">
                                            <dd><Admission_TargetPhone admission={admission} /></dd>
                                        </div>
                                    </div>
                                </div>
                                {/*{renderSmsTextBlock()}*/}
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-12 d-flex justify-content-end">
                                            <input type="button" value="Cancel" className="btn" onClick={hideModal}/>
                                            {valid ? <input type="submit" value="Send via Portal" className="btn btn-primary" onClick={doSendMessage}/>
                                                   : <input type="button" value="Validate message" className="btn btn-primary" onClick={handleValidate} disabled={loading}/>}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="personModal" tabIndex="-1" role="dialog"
                 aria-labelledby="personModalLabel" aria-modal="true">
                {renderModal()}
            </div>
        </>
    );
}

export default ModalSendMessage;